import { bind } from 'decko'
import { LiveNodeList } from 'live-node-list'
import {
  getScrollProgress,
  registerSlideshow,
  unregisterSlideshow,
} from './slideshow-helpers'

export default class SlideshowScrollbar {
  /**
   * @type {LiveNodeList}
   */
  scrollbars = new LiveNodeList('.slideshow-scrollbar')

  constructor() {
    this.registerListeners()
  }

  registerListeners() {
    this.scrollbars.on('update', (newItems, oldItems) => {
      newItems.forEach(this.registerSlideshow)
      oldItems.forEach(this.unregisterSlideshow)
    })

    this.scrollbars.addEventListener('input', this.handleChange)
    this.scrollbars.addEventListener('change', this.handleChange)
    // this.scrollbars.addEventListener('pointermove', this.handleChange)
    this.scrollbars.addEventListener('pointerdown', this.disableSnapping)
    this.scrollbars.addEventListener('pointerup', this.enableSnapping)

    this.scrollbars.forEach(this.registerSlideshow)
    this.scrollbars.addDelegatedEventListener(window, 'resize', () => {
      this.scrollbars.forEach(this.setSliderWidth)
    })
  }

  @bind
  registerSlideshow(control) {
    const slideshow = document.getElementById(
      control.getAttribute('aria-controls'),
    )

    if (!control || !slideshow) {
      return
    }

    this.setSliderWidth(control)

    registerSlideshow(control, {
      onScroll: this.handleScroll.bind(this, control, slideshow),
      onUpdateChildren: this.setSliderWidth.bind(this, control),
    })
  }

  @bind
  setSliderWidth(control) {
    const slideshow =
      control.slideshow ||
      document.getElementById(control.getAttribute('aria-controls'))

    const size =
      (slideshow.horizontal
        ? slideshow.clientWidth / slideshow.scrollWidth
        : slideshow.clientHeight / slideshow.scrollHeight) * 100

    if (!isNaN(size) && size !== 100) {
      control.style.setProperty('--scrollbar-thumb-width', `${size}%`)
    }
  }

  @bind
  unregisterSlideshow(control) {
    const slideshow = document.getElementById(
      control.getAttribute('aria-controls'),
    )

    unregisterSlideshow(control, {
      onScroll: this.handleScroll.bind(this, control, slideshow),
    })
  }

  @bind
  handleScroll(control, slideshow) {
    // if (control === document.activeElement) {
    //   return
    // }

    const progress = getScrollProgress(slideshow)
    control.value = `${progress * 100}`
    control.setAttribute('aria-valuenow', `${progress * 100}`)
  }

  @bind
  handleChange(event) {
    const control = event.currentTarget || event.target
    const slideshow =
      control.slideshow ||
      document.getElementById(control.getAttribute('aria-controls'))

    if (!control || !slideshow) {
      return
    }

    const value =
      (slideshow.horizontal
        ? slideshow.scrollWidth - slideshow.clientWidth
        : slideshow.scrollHeight - slideshow.clientHeight) *
      (parseFloat(control.value) / 100)
    const scrollOptions = slideshow.horizontal
      ? {
          left: value,
        }
      : {
          top: value,
        }

    slideshow.scrollTo(scrollOptions)
  }

  @bind
  disableSnapping(event) {
    const control = event.currentTarget || event.target
    const slideshow =
      control.slideshow ||
      document.getElementById(control.getAttribute('aria-controls'))

    slideshow.setAttribute('aria-grabbed', 'true')
    slideshow.style.scrollSnapType = 'none'
    slideshow.style.scrollBehavior = 'smooth'
  }

  @bind
  enableSnapping(event) {
    const control = event.currentTarget || event.target
    const slideshow =
      control.slideshow ||
      document.getElementById(control.getAttribute('aria-controls'))

    slideshow.setAttribute('aria-grabbed', 'false')

    const children = [...slideshow.children]

    setTimeout(() => {
      slideshow.style.scrollSnapType = null
      slideshow.style.scrollBehavior = null

      control.blur()
    }, 25)
  }
}
